// hooks/useParagraphs.js - VERSIONE AXIOS
import { useState, useEffect } from 'react';
import axios from 'axios';

export const useParagraphs = (article = null) => {
    const [paragraphs, setParagraphs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const source = axios.CancelToken.source();
        
        const fetchParagraphs = async () => {
            try {
                setLoading(true);
                setError(null);

                let url = '/api/paragraphs';
                if (article) {
                    url = `/api/paragraphs/article/${article}`;
                }

                console.log('📄 Fetching paragraphs from:', url);
                
                const response = await axios.get(url, {
                    cancelToken: source.token
                });
                
                console.log('✅ Paragraphs response:', response.data.success ? `${response.data.data?.length || 0} paragraphs` : 'Failed');
                
                if (response.data.success && Array.isArray(response.data.data)) {
                    setParagraphs(response.data.data);
                } else {
                    setParagraphs([]);
                    if (response.data.message) {
                        console.warn('⚠️ Unexpected response format:', response.data.message);
                    }
                }
                
            } catch (err) {
                if (!axios.isCancel(err)) {
                    console.error('❌ Error fetching paragraphs:', err.message);
                    setError(err.message);
                    setParagraphs([]);
                }
            } finally {
                setLoading(false);
            }
        };

        fetchParagraphs();
        
        return () => source.cancel('Component unmounted');
    }, [article]);

    return { paragraphs, loading, error };
};
